import locationApi from '@api/locationApi';
import IconLocation from '@assets/icons/location.svg?react';
import ItemList from '@components/itemList';
import LocationTile from '@components/locationTile';
import useAuth from '@hooks/useAuth';
import { useTranslator } from '@i18n';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/profile/locations/')({
  component: LocationList,
});

function LocationList() {
  const { hasClaim } = useAuth();
  const t = useTranslator();

  return (
    <ItemList
      domain="locations"
      icon={<IconLocation />}
      readonly={!hasClaim('locations/write', 'any')}
      api={locationApi}
      backButton={{ to: '/profile' }}
      title={t('locations.title')}
      renderItem={(location) => <LocationTile location={location} />}
      availableFilters={['orgId', 'createdOn']}
    />
  );
}
